// extracted by mini-css-extract-plugin
module.exports = {"scrollWrapper":"Table_scrollWrapper__1RmUW"};